import { InjectionToken } from '@angular/core';

/**
 * Bridge to the AngularJS StorageService.
 *
 * Reference: apps/b2b-ui/common/services/storage/
 *
 * PermissionsService only uses `clearAll()` (called from `clearAll()` and
 * `destroy()`). Other StorageService methods are intentionally not exposed
 * here — add them if/when a future migration needs them.
 */
export interface IStoragePort {
  clearAll(): void;
}

export const STORAGE_PORT = new InjectionToken<IStoragePort>('STORAGE_PORT');
